import { getAnalysisIcon } from '@modules/analysis/helpers';
import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';
import { Divider, Stack, Typography } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';
import { TypographyWithEllipsis } from '../TypographyWithEllipsis';

interface AnalysisFeedbackListDrawerHeaderProps {
  useCase: AnalysisUseCase;
  title: string;
  createdBy: string;
  feedbackCount?: number;
}

export const AnalysisFeedbackListDrawerHeader = ({
  useCase,
  title,
  createdBy,
  feedbackCount,
}: AnalysisFeedbackListDrawerHeaderProps) => {
  const icon = getAnalysisIcon(useCase, {
    fontSize: 'small',
    color: 'disabled',
  });

  const analysisTypeDisplayName = getAnalysisTypeDisplayName(useCase);

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Stack justifyContent="center" alignItems="center">
        {icon}
        <Typography variant="caption" color="text.secondary">
          {analysisTypeDisplayName}
        </Typography>
      </Stack>
      <Divider orientation="vertical" flexItem />
      <Stack overflow="hidden">
        <TypographyWithEllipsis variant="subtitle1">
          {title}
        </TypographyWithEllipsis>
        <Typography variant="caption" color="text.secondary">
          Created by {createdBy.trim() || 'Wisdom'}{' '}
          {feedbackCount ? `• Feedback Records: ${feedbackCount}` : ''}
        </Typography>
      </Stack>
    </Stack>
  );
};
